import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'admin-requests'
const plural = 'admin-requests'
const single = 'admin-request'

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: false,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})


api.getRequest = (requestId) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${requestId}`)
		.then(handleResponse)
		.catch(handleError)
}

api.changeStatus = (orgId, status, parameter) => {

	const params = parameter ? parameter : "";

	return axios
		.put(`${apiProvider.BASE_URL}/org/${orgId}/status/${status}`,params)
		.then(handleResponse)
		.catch(handleError)
}

api.approveOrRejectAgent = (status, parameter) => {

	const params = parameter ? parameter : "";

	return axios
		.put(`${apiProvider.BASE_URL}/admin-requests/${status}`,params)
		.then(handleResponse)
		.catch(handleError)
}

api.changeOrgAndAdminReqStatus = (orgId, status, adminRequestId, parameter ) => {

	const params = parameter ? parameter : "";
	return axios
		.put(`${apiProvider.BASE_URL}/org/${orgId}/status/${status}/${adminRequestId}`,params)
		.then(handleResponse)
		.catch(handleError)
}

api.getUrl = (orgId, file, type) => {
	const fileToUpload = file[0]
	const name = fileToUpload.name.split('.')
	const extension = name[name.length - 1]

	return axios
	.get(`${apiProvider.BASE_URL}/org/${orgId}/files/signedurl/${type}/${extension}`)
	.then(handleResponse)
	.catch(handleError)
}
api.uploadFile = (uploadUrl, file) => {
	const fileToUpload = file[0]
	return axios
			.put(uploadUrl, fileToUpload, {
				transformRequest: (data, headers) => {
					delete headers.common['Authorization'];
					return data
				},
				headers: {
					'Content-Type': fileToUpload.type
				}
			})
			.then(handleResponse)
			.catch(handleError)
}

api.scanAndSave = (key, orgId, type) => {
	return axios.post(`${apiProvider.BASE_URL}/org/${orgId}/files/upload/${type}`, { key: key })
			.then(handleResponse)
			.catch(handleError)
}

api.getConfig = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/my-info/config`)
		.then(handleResponse)
		.catch(handleError)
}

export default api
